import { Button } from "react-aria-components/Button";
import { Text, View } from "react-native";

import { SEARCH_OUTCOMES, type SearchOutcome } from "@/hooks/useMarketplaceSearch";

/** Optional feedback about the provider's results, shown after starting a search. */
export function MarketplaceSearchFeedback({ marketplace, onRespond }: {
  marketplace: string;
  onRespond: (outcome: SearchOutcome) => void;
}) {
  return (
    <View className="gap-1 py-2">
      <Text className="text-xs text-muted-foreground">
        Did you find useful sold prices on {marketplace}?
      </Text>
      <View className="flex-row flex-wrap gap-x-3 gap-y-1">
        {SEARCH_OUTCOMES.map(([outcome, label]) => (
          <Button
            key={outcome}
            onPress={() => onRespond(outcome)}
            className="min-h-11 border-0 bg-transparent p-0 text-left font-label text-xs text-primary cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
          >
            {label}
          </Button>
        ))}
      </View>
    </View>
  );
}
